import { Container } from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";

const SessionApiDocs = () => {
  return (
    <Container>
      <BackBtn />
    </Container>
  );
};

export default SessionApiDocs;
